
	/**
	 * @description
	 *	Tupla genérica inmutable.
	 */

export class Tuple<T, U> {

	private readonly _value1: T;
	private readonly _value2: U;

	private constructor(value1: T, value2: U) {
		this._value1 = value1;
		this._value2 = value2;
	}

	public static of<T, U>(value1: T, value2: U): Tuple<T, U> {
		return new Tuple<T, U>(value1, value2);
	}

	public get value1(): T {
		return this._value1;
	}

	public get value2(): U {
		return this._value2;
	}
}
